export const DIVIDER = {
  ORIENTATION: { HORIZONTAL: "horizontal", VERTICAL: "vertical" },
  SIZE: { SECTION: "section", CELL: "cell", SEMI: "semi", GROUP: "group" },
};